module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home.component.less
// module id = ./src/app/components/home/home.component.less
// module chunks = main